var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OverlayPanel } from 'primereact/overlaypanel';
import * as React from 'react';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import { CurrentUser } from "../../classes/definitions/currentUser/CurrentUser";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import Logo from '../Logo/Logo';
import './Header.css';
import headerReduxProps from "./HeaderReduxProps";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentUser = CurrentUser.getInstance();
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            isOverlayPanelVisible: false,
            viewingAsUser: localStorage.getItem('viewingAsUser')
        };
        _this.sidebarHandler = function () {
            if (_this.props.sidebarVisible) {
                _this.props.onHideSidebar();
            }
            else if (!_this.props.sidebarVisible) {
                _this.props.onShowSidebar();
            }
        };
        _this.showEditUserModal = function () {
            _this.props.onShowSelfEditUserModal();
            _this.props.onHideSelfEditUserList();
            _this.setState({ isOverlayPanelVisible: false });
        };
        _this.showEditPassModal = function () {
            _this.props.onShowSelfEditPassModal();
            _this.props.onHideSelfEditUserList();
        };
        _this.selfEditListHandler = function () {
            if (_this.props.userSelfEditListVisible) {
                _this.props.onHideSelfEditUserList();
            }
            else if (!_this.props.userSelfEditListVisible) {
                _this.props.onShowSelfEditUserList();
            }
        };
        _this.onMouseLeaveAction = function () {
            _this.props.onHideSelfEditUserList();
        };
        _this.hideOverlayPanel = function () {
            _this.setState({ isOverlayPanelVisible: false });
        };
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        if (this.currentUser.LoginCount === 1) {
            this.setState({ isOverlayPanelVisible: true });
        }
    };
    Header.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.switchTenantButtonVisible !== this.props.switchTenantButtonVisible) {
            var viewingAsUser = '';
            localStorage.getItem('viewingAsUser') !== null ?
                viewingAsUser = localStorage.getItem('viewingAsUser') :
                viewingAsUser = '';
            this.setState({ viewingAsUser: viewingAsUser });
        }
    };
    Header.prototype.render = function () {
        var isOverlayPanelVisible = this.state.isOverlayPanelVisible;
        var userSelfEditListVisible = this.props.userSelfEditListVisible;
        return (React.createElement("header", { className: "app-header navbar", onMouseLeave: this.onMouseLeaveAction },
            React.createElement("button", { onClick: this.sidebarHandler, className: "navbar-toggler sidebar-toggler d-lg-none mr-auto", type: "button", "data-toggle": "sidebar-show" },
                React.createElement("span", { className: "navbar-toggler-icon" })),
            React.createElement(NavLink, { className: "navbar-brand", to: "/" },
                React.createElement(Logo, { width: '170', height: 'auto', alt: 'Prettyshop' })),
            React.createElement("button", { onClick: this.sidebarHandler, className: "navbar-toggler sidebar-toggler d-md-down-none", type: "button", "data-toggle": "sidebar-lg-show" },
                React.createElement("span", { className: "navbar-toggler-icon" })),
            React.createElement("ul", { className: "nav navbar-nav ml-auto" }),
            React.createElement("ol", { className: userSelfEditListVisible ? 'self-edit-list' : 'hide-self-edit-list' },
                React.createElement("li", { onClick: this.showEditUserModal, className: 'self-edit-list-li' },
                    React.createElement("i", { className: "fa fa-edit user-edit-icon" }),
                    React.createElement("a", { className: 'self-edit-list-a' }, "Edit user")),
                React.createElement("li", { onClick: this.showEditPassModal, className: 'self-edit-list-li' },
                    React.createElement("i", { id: "lock-icon", className: "fa fa-lock user-edit-icon" }),
                    React.createElement("a", { id: 'anchor-lock-li', className: 'self-edit-list-a' }, "Change password"))),
            React.createElement(OverlayPanel, { onHide: this.hideOverlayPanel, className: "overlay-panel " + (isOverlayPanelVisible ? ' show-overlay-panel' : 'hide-overlay-panel'), showCloseIcon: true, dismissable: true },
                React.createElement("p", { className: 'overlay-panel-text' }, "You can activate/deactivate two-factor authentication from Edit User menu!"))));
    };
    ;
    return Header;
}(React.Component));
export default connect(headerReduxProps.mapStateToProps, headerReduxProps.mapDispatchToProps)(Header);



//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.tsx
// module id = 209
// module chunks = 0